export default __webpack_public_path__ + "static/media/Logo.394a5fe9.webp";